import React, { useEffect, useState, createContext } from "react";
// import { auth, provider } from "../firebase-config";
// import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase-config";
import { getDocs, collection } from "firebase/firestore";
import "./../styles/form.css";

// Create a Context
export const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
      const loginStatus = localStorage.getItem("isLogin");
      setIsLogin(loginStatus);
  }, []);

  return (
      <AuthContext.Provider value={{ isLogin }}>
          {children}
      </AuthContext.Provider>
  );
};

function Login({ setIsAuth }) {
  let navigate = useNavigate();
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  //   const signInWithGoogle = () => {
  //     signInWithPopup(auth, provider).then((result) => {
  //       localStorage.setItem("isAuth", true);
  //       setIsAuth(true);
  //       navigate("/");
  //     });
  //   };

  const userInfoCollectionRef = collection(db, "AdminUser");
  const [userInfo, setUserInfo] = useState([]);
  const [userProfileData, setUserProfileData] = useState({
    name: "",
    password: "",
  });

  useEffect(() => {
    const getUser = async () => {
      const data = await getDocs(userInfoCollectionRef);
      setUserInfo(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      //console.log(data.docs[0]._document.data.value.mapValue.fields.name);
    };
    getUser();
  }, [userInfoCollectionRef]);

  function matchData(e) {
    const newData = { ...userProfileData };
    newData[e.target.id] = e.target.value;
    setUserProfileData(newData);
    // console.log(userInfo[0].name);
  }
  const verify = async (event) => {
    const success = (document.getElementById("success").style.display =
      "block");
    if (
      userInfo[0].name === userProfileData.name &&
      userInfo[0].password === userProfileData.password
    ) {
      localStorage.setItem("isLogin", true);
      document.getElementById("failed").style.display = "none";
      await delay(2000, success).then(() => {
        navigate("/");
      });
    } else {
      document.getElementById("failed").style.display = "block";
      document.getElementById("success").style.display = "none";
    }
  };

  return (
    <>
      {/* <div className="loginForm">
        <p>Sign in with Google to continue.</p>
        <button className="login-btn" onClick={signInWithGoogle}>
          Sign in with Google
        </button>
      </div> */}
      {/* <div>
        {userInfo && userInfo.map((user, i) => {
          return (
            <>
              <div key={i}>
                {user.password}
              </div>
            </>
          );
        })}
      </div> */}
      <div className="formUI login">
        <h2>Login</h2>
        <div className="createForm">
          <div className="fields">
            <label htmlFor="">User Name</label>
            <input
              onChange={(e) => matchData(e)}
              id="name"
              value={userProfileData.name}
              placeholder="User Name"
              type="text"
            />
          </div>
          <div className="fields">
            <label htmlFor="">Password</label>
            <input
              onChange={(e) => matchData(e)}
              id="password"
              value={userProfileData.password}
              placeholder="******"
              type="password"
            />
          </div>
          <div className="fields">
            <button className="createBtn" id="sub" onClick={verify}>
              Login
            </button>
          </div>
          <p style={{ display: "none" }} id="success">
            Login Successfully!
          </p>
          <p style={{ display: "none" }} id="failed">
            Login Failed!
          </p>
        </div>
      </div>
    </>
  );
}

export default Login;
